import { ChangeEvent } from 'react'

import { useTableData } from '@/hooks/useTableData'

import CustomGraphy from '../CustomGraphy'
import CustomView from '../CustomView'
import FormSelectInput from '../FormSelectInput'
import TablePagination from './TablePagination'
import { useSearchParams } from '@/hooks/useSearchParams'

interface ITableFooter {
  totalCount: number
  disableSearchParams?: boolean
}

function TableFooter({ totalCount, disableSearchParams = false }: ITableFooter) {
  const { PER_PAGE, SET_PER_PAGE, CURRENTE_PAGE } = useTableData()
  const {includeParamsToUrl} = useSearchParams()
  const initialIndex = (CURRENTE_PAGE - 1) * PER_PAGE
  const finalIndex = initialIndex + PER_PAGE
  const options = ['10', '20', '30', '100']

  function handleItemsPerPage(event: ChangeEvent<HTMLInputElement>) {
    const pageSize = Number(event.target.value)
    SET_PER_PAGE(pageSize)
    if(!disableSearchParams) includeParamsToUrl({ pageSize })
  }

  return (
    <CustomView
      px={{ xs: '10px', md: '24px' }}
      alignItems="center"
      justifyContent="space-between"
      backColor="white"
      borderTop="1px solid #d5d7d8"
      flexDirection={{ xs: 'column', md: 'row' }}
    >
      <CustomView
        flexDirection="row"
        alignItems="center"
        justifyContent={{ xs: 'space-between', md: 'flex-start' }}
      >
        <CustomGraphy>Exibir até</CustomGraphy>
        <CustomView width="100%" maxWidth="80px">
          <FormSelectInput
            id="pageSize"
            name="pageSize"
            value={PER_PAGE}
            onChange={handleItemsPerPage}
            options={options}
          />
        </CustomView>
        <CustomGraphy>
          {initialIndex + 1} -{' '}
          {finalIndex > totalCount ? totalCount : finalIndex} de {totalCount}{' '}
          resultados
        </CustomGraphy>
      </CustomView>
      <TablePagination totalCount={totalCount} disableSearchParams={disableSearchParams}/>
    </CustomView>
  )
}

export default TableFooter
